export const DEFAULT_LANG = process.env.DEFAULT_LANG ?? 'es';
export const AVAILABLE_LANGS: string[] = ['es', 'en'];

const langsConstants = {
    DEFAULT_LANG,
    AVAILABLE_LANGS
};

export default langsConstants;
